// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.MenuToolbar.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * MenuToolbar component
 */
import React, { Component } from 'react';
import LayoutUtils from 'share/utils/Izenda.LayoutUtils';

export default class MenuToolbar extends Component {
  closeMenuToolbar() {
    LayoutUtils.togglePropertiesEditor(false);
  }

  dropdownRef = (dom: any) => {
    dom && $izenda(dom).dropdown();
  };

  render() {
    const { menuItems } = this.props;

    return (
      <div className='izenda-MenuToolbar'>
        <div className='izenda-MenuToolbar-close' onClick={this.closeMenuToolbar}>
          <span className='icon-left-open' />
        </div>
        <div className='izenda-MenuToolbar-menu'>
          <a ref={this.dropdownRef} className='btn u-colorWhite' data-toggle='dropdown'>
            <span className='icon-menu-pro' />
          </a>
          <ul className='dropdown-menu dropdown-menu-right'>{menuItems}</ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.MenuToolbar.js